const routes = [
    {
        path: "/20/zjd",
        children: [
            {
                path: "20_20241104khysj",
                component: () => import("@/views/20/zjd/20241104/index.vue"),
                meta: {
                    sign: "20_20241104khysj",
                },
            },
            {
                path: "20_20241104khgch",
                component: () => import("@/views/20/zjd/20241104/index.vue"),
                meta: {
                    sign: "20_20241104khgch",
                },
            },
            {
                path: "20_20241217test",
                component: () => import("@/views/20/zjd/20241217/index.vue"),
                meta: {
                    sign: "20_20241217test",
                },
            },
            {
                path: "20_20250304khgch",
                component: () => import("@/views/20/zjd/20250304/index.vue"),
                meta: {
                    sign: "20_20250304khgch",
                },
            },
            {
                path: "20_20250304khysj",
                component: () => import("@/views/20/zjd/20250304/index.vue"),
                meta: {
                    sign: "20_20250304khysj",
                },
            },
            {
                path: "20_20250703khgch",
                component: () => import("@/views/20/zjd/20250703/index.vue"),
                meta: {
                    sign: "20_20250703khgch",
                },
            },
            {
                path: "20_20250703khysj",
                component: () => import("@/views/20/zjd/20250703/index.vue"),
                meta: {
                    sign: "20_20250703khysj",
                },
            }
        ],
    },
];

export default routes;
